import { createBlankEditStep } from "@/lib/workoutPrescriptionFormatters";

const inputClass = "w-full border border-dark-border bg-dark-background px-2 py-1 text-sm text-dark-text-primary";

const StepFields = ({ step, onChange, onRemove, testId }) => (
  <div className="rounded-md border border-dark-border/70 bg-dark-surface p-3 space-y-2" data-testid={testId}>
    <div className="grid gap-2 sm:grid-cols-2">
      <label className="block text-xs sm:col-span-2">
        <span className="mb-1 block text-dark-text-secondary">Step label</span>
        <input
          type="text"
          value={step.label}
          onChange={(e) => onChange({ ...step, label: e.target.value })}
          className={inputClass}
          data-testid={`${testId}-label`}
        />
      </label>
      <label className="block text-xs">
        <span className="mb-1 block text-dark-text-secondary">Duration (min)</span>
        <input
          type="number"
          min="0"
          step="0.5"
          value={step.duration_minutes}
          onChange={(e) => onChange({ ...step, duration_minutes: e.target.value })}
          className={inputClass}
          data-testid={`${testId}-duration`}
        />
      </label>
      <label className="block text-xs">
        <span className="mb-1 block text-dark-text-secondary">Repeat</span>
        <input
          type="number"
          min="1"
          step="1"
          value={step.repeat_count}
          onChange={(e) => onChange({ ...step, repeat_count: e.target.value })}
          className={inputClass}
          data-testid={`${testId}-repeat`}
        />
      </label>
      <label className="block text-xs sm:col-span-2">
        <span className="mb-1 block text-dark-text-secondary">Intensity / target</span>
        <input
          type="text"
          value={step.intensity_text}
          onChange={(e) => onChange({ ...step, intensity_text: e.target.value })}
          className={inputClass}
          data-testid={`${testId}-intensity`}
        />
      </label>
      <label className="block text-xs sm:col-span-2">
        <span className="mb-1 block text-dark-text-secondary">Coaching cue (optional)</span>
        <input
          type="text"
          value={step.athlete_cue}
          onChange={(e) => onChange({ ...step, athlete_cue: e.target.value })}
          className={inputClass}
          data-testid={`${testId}-cue`}
        />
      </label>
    </div>
    {onRemove && (
      <button
        type="button"
        onClick={onRemove}
        className="text-[10px] uppercase tracking-widest text-red-400"
        data-testid={`${testId}-remove`}
      >
        Remove step
      </button>
    )}
  </div>
);

const SectionEditor = ({
  title,
  steps,
  onChange,
  testId,
}) => {
  const updateStep = (index, next) => {
    onChange(steps.map((step, idx) => (idx === index ? next : step)));
  };

  const removeStep = (index) => {
    onChange(steps.filter((_, idx) => idx !== index));
  };

  return (
    <section className="space-y-3" data-testid={testId}>
      <div className="flex items-center justify-between gap-2">
        <div className="text-[11px] uppercase tracking-[0.25em] text-dark-text-muted">
          {title}
        </div>
        <button
          type="button"
          onClick={() => onChange([...(steps || []), createBlankEditStep()])}
          className="text-[10px] uppercase tracking-widest text-brand-primary"
          data-testid={`${testId}-add`}
        >
          Add step
        </button>
      </div>
      <div className="space-y-2">
        {(steps || []).map((step, index) => (
          <StepFields
            key={`${testId}-${index}`}
            step={step}
            onChange={(next) => updateStep(index, next)}
            onRemove={() => removeStep(index)}
            testId={`${testId}-step-${index}`}
          />
        ))}
      </div>
    </section>
  );
};

export const PrescriptionStepsEditor = ({
  warmup,
  mainSet,
  cooldown,
  onWarmupChange,
  onMainSetChange,
  onCooldownChange,
}) => (
  <div className="space-y-5" data-testid="prescription-steps-editor">
    <SectionEditor
      title="Warm-up"
      steps={warmup}
      onChange={onWarmupChange}
      testId="prescription-editor-warmup"
    />
    <SectionEditor
      title="Main set"
      steps={mainSet}
      onChange={onMainSetChange}
      testId="prescription-editor-main-set"
    />
    <SectionEditor
      title="Cool-down"
      steps={cooldown}
      onChange={onCooldownChange}
      testId="prescription-editor-cooldown"
    />
  </div>
);
